import { createContext } from "common/utils/reactContext";
import { type GetCurrentStaffUserQuery } from "common/types/gqlSchemaTypes";

export type UserContextType = {
  user?: GetCurrentStaffUserQuery["currentUser"];
};

const [useUserContext, UserContext] = createContext<UserContextType>();
export { useUserContext, UserContext };
